import { isNil } from 'lodash/fp';

import extractRelativePath from '../../../../elements/header/utils/extract-perk-url';

// @ts-expect-error - Automatic, Please fix when editing this file
const buildCtaProps = (perk) => {
  let ctaText = perk?.descriptionTeaser;
  if (isNil(ctaText)) {
    ctaText = perk?.urlObject?.name;
  }

  return {
    ctaText,
    ctaUrl: extractRelativePath(perk),
  };
};

export default buildCtaProps;
